import * as React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ExchangeRateProvider } from './context/ExchangeRateContext';

const clientId = '775147165331-r37i1r9t60rn3ani80u9umplkhhm1ru5.apps.googleusercontent.com';

window.addEventListener('error', function (event) {
  if (
    event.message &&
    event.message.includes("Cannot set properties of undefined (setting 'visibleRange')")
  ) {
    event.preventDefault();
  }
});
window.addEventListener('unhandledrejection', function (event) {
  if (
    event.reason &&
    typeof event.reason.message === 'string' &&
    event.reason.message.includes("Cannot set properties of undefined (setting 'visibleRange')")
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <ExchangeRateProvider>
        <App />
      </ExchangeRateProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();